var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37417 7.76502C1.31863 7.91464 1.31863 8.07923 1.37417 8.22885C1.9151 9.54044 2.83329 10.6619 4.01235 11.451C5.1914 12.2401 6.57822 12.6614 7.99698 12.6614C9.41574 12.6614 10.8026 12.2401 11.9816 11.451C13.1607 10.6619 14.0789 9.54044 14.6198 8.22885C14.6753 8.07923 14.6753 7.91464 14.6198 7.76502C14.0789 6.45343 13.1607 5.33198 11.9816 4.54285C10.8026 3.75373 9.41574 3.33246 7.99698 3.33246C6.57822 3.33246 5.1914 3.75373 4.01235 4.54285C2.83329 5.33198 1.9151 6.45343 1.37417 7.76502Z",
    stroke: "#4A5565",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9968 9.99619C9.10094 9.99619 9.99603 9.1011 9.99603 7.99695C9.99603 6.8928 9.10094 5.99771 7.9968 5.99771C6.89265 5.99771 5.99756 6.8928 5.99756 7.99695C5.99756 9.1011 6.89265 9.99619 7.9968 9.99619Z",
    stroke: "#4A5565",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.9788ad5e53c4f7fe0d0ee66b9f8aa945.svg";
export { ForwardRef as ReactComponent };